/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { useIsPremiumEdition } from '@jira/polaris__lib-entitlement-utils/src/index.tsx';
import { useProductEntitlementDetails } from '@atlassian/jira-tenant-context-controller/src/components/product-entitlement-details/index.tsx';
import { JIRA_PRODUCT_DISCOVERY_PRODUCT_KEY } from './jiraProductDiscoveryProductKey.constants.tsx';

export const useIsPremiumLozengeVisible = (): boolean | 0 | undefined => {
	const isPremium = useIsPremiumEdition();
	const productEntitlementDetails = useProductEntitlementDetails();

	const trialEndDate: number | undefined =
		productEntitlementDetails?.[JIRA_PRODUCT_DISCOVERY_PRODUCT_KEY]?.trialEndTime;

	return useMemo(() => {
		return isPremium && trialEndDate && trialEndDate - Date.now() > 0;
	}, [trialEndDate, isPremium]);
};
